
export { MainLogo } from "../../logos/src/components/MainLogo"